import { Expose, Type } from 'class-transformer';
import { Point } from 'geojson';

import { SnModel } from '@lib/common/models';

import { SnFloor, SnLocation } from '../location';
import { SecurityServer } from './security-server';

export class AccessPoint extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  @Type(() => SecurityServer)
  public server: SecurityServer;

  @Expose()
  @Type(() => SnLocation)
  public location: SnLocation;

  @Expose()
  @Type(() => SnFloor)
  public floor: SnFloor;

  @Expose()
  public createdTimestamp: Date;

  @Expose()
  public updatedTimestamp: Date;

  @Expose()
  public name: string;

  @Expose()
  public pointId: string;

  @Expose()
  public type: string;

  @Expose()
  public status: string;

  @Expose()
  public geometry: Point;

  @Expose()
  public heading: number;

  @Expose()
  public icon: string;

  @Expose()
  public color: string;

  @Expose()
  public cameras: string[];

  constructor(data: Object = {}) {
    super();

    this.fromJSON(data);
  }
}
